import VideoJsAdapter from '../../../adapters/videojs_adapter';
import Component from '../../component';
import { titleElement, descriptionElement, countdownElement, thumbnailElement } from './elements';
import createElement from '../../../utils/create_element';
import Countdown from './countdown';
import { sendImpressionEvent, sendClickEvent } from '../../../service/next_video/tracker';

export default class Index extends Component {
  constructor(player, options = {}){
    super(player, options);
  }

  createEl(){
    let el = super.createEl('div', {
      className: 'vjs-next-video-service'
    });

    this._thumbnailElement = createElement(thumbnailElement(this.nextWatchpageUrl(), this.options().image_url));
    this._thumbnailElement.addEventListener('click', this.onButtonClick.bind(this));
    el.appendChild(this._thumbnailElement);

    this._dataWrapperElement = createElement(`
      <a href='${this.nextWatchpageUrl()}' class='vjs-next-video-service__data-container'>
        ${titleElement(this.options().title)}
        ${descriptionElement(this.options().description)}
      </a>
      `);
    this._dataWrapperElement.addEventListener('click', this.onButtonClick.bind(this));

    this._countdownElement = createElement(countdownElement(''));
    this._countdown = new Countdown({
      player: this.player(),
      element: this._countdownElement,
      nextUrl: this.nextWatchpageUrl(),
      nextVideoId: this.options().id
    });
    this._dataWrapperElement.prepend(this._countdownElement);

    this._closeButtonElement = createElement(`<button class='vjs-next-video-service__close'></button>`);
    this._closeButtonElement.addEventListener('click', this.triggerClose.bind(this))

    el.appendChild(this._dataWrapperElement);
    el.appendChild(this._closeButtonElement);

    return el;
  }

  ready() {
    this.player().on('next_video_show', this.onComponentShown.bind(this));
    this.countdown().init();
  }

  countdown(){
    return this._countdown;
  }

  nextWatchpageUrl(){
    if(this.options().watchpage_url !== undefined){
      return this.options().watchpage_url;
    }else{
      return `/watch/${this.options().id}`;
    }
  }

  onButtonClick(){
    sendClickEvent(this.options().id);
  }

  triggerClose(){
    this.player().trigger('nextvideo_close');
    this.countdown().clearCountdownInterval();
  }

  onComponentShown(){
    sendImpressionEvent(this.options().id);
  }

  closePanelOnRePlaying(){
    this.player().one("playing", this.triggerClose.bind(this));
  }
}

VideoJsAdapter.registerComponent('VpNextVideo', Index);
